"use client";

// import { redirect } from "next/navigation";

export default function Error({
  // eslint-disable-next-line no-unused-vars
  error
}: {
  error: Error & { digest?: string };
}) {
  console.error("Error", error?.message || error);
  // return redirect(`${process.env.BASE_URL}`);
}
